import CustomerScreen from './index';

const routes = [
  {
    path: '/master/customer',
    component: CustomerScreen,
  },
];

export default routes;
